import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltInlineCommentsSectionFilterDropdownContentListItemWireframe from './VeltInlineCommentsSectionFilterDropdownContentListItemWireframe/VeltInlineCommentsSectionFilterDropdownContentListItemWireframe';
var VeltInlineCommentsSectionFilterDropdownContentListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-filter-dropdown-content-list-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionFilterDropdownContentListWireframe.Item = VeltInlineCommentsSectionFilterDropdownContentListItemWireframe;
export default VeltInlineCommentsSectionFilterDropdownContentListWireframe;
